import Vue from 'vue'
import elDragDialog from './el-drag-dialog'
import waves from './waves'

Vue.directive('el-drag-dialog', elDragDialog)
Vue.directive('waves', waves)
